import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class UnverifiedEmailError extends CodedError {
  static get errorName() {
    return errorCodes.unverifiedEmailError.code;
  }

  constructor(message: string = errorCodes.unverifiedEmailError.message) {
    super(message);
    this.code = errorCodes.unverifiedEmailError.code;
    this.message = `${message} ${errorCodes.unverifiedEmailError.code}`;
    this.name = errorCodes.unverifiedEmailError.name;
  }
}
